module.exports = __webpack_public_path__ + "img/button_share_dark_arrow.b77daa1a.png";